const insertDataInLocalDb = (USER_DATA_ITEM, TBL, refId) => {

  if (!window.indexedDB) {
    console.error("IndexedDB not supported");
    return;
  }

  const DB_NAME = "_evol_spearup_db_1";
  const DB_VERSION = 1; // ⬅️ IMPORTANT: bump version
  const request = indexedDB.open(DB_NAME, DB_VERSION);

  request.onerror = (event) => {
    console.error("IndexedDB error", event);
  };

  // 🔥 CREATE STORE HERE
  request.onupgradeneeded = (event) => {
    const db = event.target.result;

    if (!db.objectStoreNames.contains(TBL)) {
      db.createObjectStore(TBL, {
        keyPath: "id"
      });
      //console.log(`✅ ObjectStore '${TBL}' created`);
    }
  };

  request.onsuccess = () => {
    const db = request.result;

    if (!db.objectStoreNames.contains(TBL)) {
      //console.error(`❌ ObjectStore '${TBL}' does not exist`);
      return;
    }

    const tx = db.transaction(TBL, "readwrite");
    const store = tx.objectStore(TBL);

    const data = USER_DATA_ITEM;

    // Use primary key lookup (NOT cursor misuse)
    const getReq = store.get(refId);

    getReq.onsuccess = () => {
      if (getReq.result) {
        // update
        store.put(data);
      } else {
        // insert
        store.add(data);
      }
    };

    tx.oncomplete = () => {
      //console.log("✅ IndexedDB transaction completed");
    };

    tx.onerror = (e) => {
      //console.error("❌ Transaction failed", e);
    };
  };
};

export default insertDataInLocalDb;
